<template>
    <div class="row" :key="tick">
        <div class="col-lg">
            <div><ul class="select"><li v-for="t in typeList" :key="t" class="item"><a href="#" v-on:click.prevent="type = t" :class="[(t == type) ? 'button-active' : '', 'button']">{{translatedtype(t)}}</a></li></ul></div>
            <div>
                <div class="cron-option" style=" margin:0.5rem; padding-bottom:10px">
                    <input type="radio" id="cronEvery" v-model="expressionArray[type].subType" value="every" name="cron">
                    <label for="cronEvery" class="nofloat">Jede(r) {{translatedtype(type)}}</label>
                </div>
                <div class="cron-option" style="margin:0.5rem; padding-bottom:10px">
                    <input type="radio" id="cronIncrement" v-model="expressionArray[type].subType" value="everyIncr" name="cron">
                    <label for="cronIncrement" class="nofloat">Jede(r)
                        <select id="cronIncrementIncrement" v-model="expressionArray[type].interval" style="width:50px;">
                            <option v-for="(n, index) in cronIncrement(type)" :key="'p1'+index" :value="index+1">{{index+1}}</option>
                        </select> {{translatedtype(type)}}(n) beginnend um/am {{translatedtype(type)}}
                        <select id="cronIncrementStart" v-model="expressionArray[type].start" style="width:50px;">
                            <option v-for="(n, index) in cronIncrement(type)" :key="'p2'+index" :value="getSpecificValueByType(type,index)">{{getSpecificValueByType(type,index)}}</option>
                        </select>
                    </label>
                </div>
                <div style="margin:0.5rem; padding-bottom:10px" :class="[(validateSpecific) ? 'is-invalid':'','cron-option']">
                    <input type="radio" id="cronSpecific" v-model="expressionArray[type].subType" value="specific" checked="checked" name="cron">
                    <label for="cronSpecific" class="nofloat" >Spezifische(r) {{translatedtype(type)}} (Mehrfachselektion möglich - wenn nichts ausgewählt, wird "1" gesetzt))</label>
                    <div style="margin-left:50px;">
                        <div v-for="(n, index) in cronIncrement(type)" :key="'p3'+index" style="float: left; padding-left: 1rem;">
                            <label :for="'cronMinute'+index" class="nofloat" style="padding-right: 5px;">{{getSpecificValueByType(type,index)}}</label>
                            <input @change="clearSpecificExpression(type)" type="checkbox" :id="'cronMinute'+index" name="cronSpecificSpecific" :value="getSpecificValueByType(type,index)" v-model="expressionArray[type].specific" style="padding-left: 0.5rem;">
                        </div>
                    </div>
                    <div style="clear:both;"></div>
                </div>
                <div class="cron-option" style="margin:0.5rem; padding-bottom:10px">
                    <input type="radio" id="cronRange" v-model="expressionArray[type].subType" value="range" name="cron">
                    <label for="cronRange" class="nofloat">Jede(r) {{translatedtype(type)}} zwischen {{translatedtype(type)}}
                        <select id="cronRangeStart" v-model="expressionArray[type].start" style="width:50px;">
                            <option v-for="(n, index) in cronIncrement(type)" :key="'p4'+index" :value="getSpecificValueByType(type,index)">{{getSpecificValueByType(type,index)}}</option>
                        </select>
                        and {{translatedtype(type)}}
                        <select id="cronRangeEnd" v-model="expressionArray[type].end" style="width:50px;">
                            <option v-for="(n, index) in cronIncrement(type)" :key="'p5'+index" :value="getSpecificValueByType(type,index)">{{getSpecificValueByType(type,index)}}</option>
                        </select>
                    </label>
                </div>
                <div v-if="type === 'day'" class="cron-option" style="margin:0.5rem; padding-bottom:10px">
                    <input type="radio" id="cronLastDayOfMonth" v-model="expressionArray[type].subType" value="ldom" name="cron">
                    <label for="cronLastDayOfMonth" class="nofloat">Am letzten Tag des Monats</label>
                </div>
                <div v-if="type === 'day'" class="cron-option" style="margin:0.5rem; padding-bottom:10px">
                    <input type="radio" id="cronDaysBeforeEom" v-model="expressionArray[type].subType" value="dbeom" name="cron">
                    <label for="cronDaysBeforeEom" class="nofloat">
                        <select id="cronDaysBeforeEomMinus" v-model="expressionArray[type].start" style="width:50px;">
                            <option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option>
                        </select> Tag(e) vor Monatsende
                    </label>
                </div>
                <h4 v-if="type === 'day'" class="cron-option text-muted" style="margin:0.5rem; padding-bottom:10px">
                    Erweiterte Möglichkeiten zur Bestimmung des Ausführungstages. Sofern erweitere Einstellungen gewählt werden, stellen Sie die korrekte Ausführung über die Vorschau sicher. Eine Kombination mit den vorherigen Einstellungen ist möglich.
                </h4>
                <div v-if="type === 'day'" class="cron-option" style="margin:0.5rem; padding-bottom:10px">
                    <input type="radio" id="cronDowSpecific" v-model="expressionArray.dow.subType" value="specificDay" name="cron">
                    <label for="cronDowSpecific" class="nofloat">Spezifischer Wochentag (Mehrfachselektion möglich))</label>
                    <div style="margin-left:50px;">
                        <div v-for="(day,index) in weekdays" :key="'p6'+day" style="float: left; padding-left: 1rem;">
                            <label :for="'cronDow'+day" class="nofloat">{{day}}</label>
                            <input type="checkbox" @change="clearSpecificExpression('dow')" :id="'cronDow'+day" name="cronDowSpecificSpecific" :value="index" v-model="expressionArray.dow.specific" checked>
                        </div>
                    </div>
                    <div style="clear:both;"></div>
                </div>
                <div v-if="type === 'day'" class="cron-option" style="margin:0.5rem; padding-bottom:10px">
                    <input type="radio" id="cronNthDay" v-model="expressionArray.dow.subType" value="nthday" name="cron">
                    <label for="cronNthDay" class="nofloat">
                        Am
                        <select id="cronNthDayNth" v-model="expressionArray.dow.start" style="width:50px;">
                            <option value="1">1.</option>
                            <option value="2">2.</option>
                            <option value="3">3.</option>
                            <option value="4">4.</option>
                            <option value="5">5.</option>
                        </select>
                        <select id="cronNthDayDay" v-model="expressionArray.dow.end" style="width:125px;">
                            <option v-for="(name,day) in weekdays" :key="'p6'+day" :value="day">{{name}}</option>
                        </select>
                        des Monats
                    </label>
                </div>
            </div>
        </div>

        <div class="col-lg">
            <h3 style="margin:0.5rem;">Preview</h3>
            <!---- <input :value="value" v-on:input="handleInput(value)"/> ---->
            <p style="margin:0.5rem;">
            {{humanReadableString}}</p>
            <hr>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    // cRonstrue for human readable cron description from https://bradymholt.github.io/cRonstrue
    import cronstrue from 'cronstrue/i18n';


    export default {
        name:"CronEditor",
        props: {
            value: {
                type: String,
                default: '* * * * *'
            },
            locale: {
                type: String,
                default: 'en'
            }
        },
        data() {
            return {
                init: 1,
                tick: 1,
                type: 'minute',
                allTypes: ['minute','hour','day','month'],
                weekdays: ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'],
                daySorter: {
                    "sunday": 0, // << if sunday is first day of week
                    "monday": 1,
                    "tuesday": 2,
                    "wednesday": 3,
                    "thursday": 4,
                    "friday": 5,
                    "saturday": 6,

                },
                weekdaysShort: ['SUN','MON','TUE','WED','THU','FRI','SAT'],
                translation: {
                   minute : 'Minute',
                   hour: 'Stunde',
                   day: 'Tag',
                   month: 'Monat'
                },
                expressionArray: {
                    minute: {subType: 'every',specific : [0],interval: 1,start: 0,end: 0},
                    hour: {subType: 'every',specific : [0],interval: 1,start: 0,end: 0},
                    day: {subType: 'every',specific : [1],interval: 1,start: 1,end: 30},
                    dow: {subType: 'every',specific : [0],interval: 1,start: 1,end: 0},
                    month: {subType: 'every',specific : [1],interval: 1,start: 1,end: 12},
                    year: {subType: 'every',specific : [new Date().getFullYear()],interval: 1,start: new Date().getFullYear(),end: new Date().getFullYear()}},
                expressionArrayDefault: {
                    minute: {subType: 'every',specific : [0],interval: 1,start: 0,end: 0},
                    hour: {subType: 'every',specific : [0],interval: 1,start: 0,end: 0},
                    day: {subType: 'every',specific : [1],interval: 1,start: 1,end: 30},
                    dow: {subType: 'every',specific : [0],interval: 1,start: 1,end: 0},
                    month: {subType: 'every',specific : [1],interval: 1,start: 1,end: 12},
                    year: {subType: 'every',specific : [new Date().getFullYear()],interval: 1,start: new Date().getFullYear(),end: new Date().getFullYear()}}
            }
        },
        mounted()  {
            this.initScript();
        },
        computed: {
            typeList() {
                return (typeof this.types !== 'undefined') ? this.types : this.allTypes;
            },
            humanReadableString() {
                return (this.tick > 0) ? cronstrue.toString(this.createExpression(),{locale: this.locale}) : '-';
            },
            daySubtype() {
                return this.expressionArray.day.subType
            },
            dowSubtype() {
                return this.expressionArray.dow.subType
            },
            validateSpecific(){
                return this.checkSpecific(this.type)
            }
        },
        watch: {
            expressionArray: {
                handler() { if (!this.init) {
                    this.$emit('input', this.createExpression());
                    this.tick++;
                }  },
                deep:true
            },
           daySubtype(){
                this.expressionArray.dow.subType = 'every';
                this.tick++;
           },
            dowSubtype(){
                this.expressionArray.day.subType = 'every';
                this.tick++;
            }
        },
        methods: {
            handleInput (value) {
                this.$emit('blur', value)
            },
            clearSpecificExpression(type){
                this.expressionArray[type].specific = this.expressionArray[type].specific.filter(item => { return item !== '' });
                if (this.expressionArray[type].specific.length === 0) this.expressionArray[type].specific.push(1);
                this.tick++
            },
            createExpressionPart:function (cronPart,type) {
                cronPart = JSON.parse(JSON.stringify(cronPart));
                let exp = '*';
                let decr = (type === 'day'|| type === 'month') ? 0 : 1;
                switch (cronPart.subType) {
                    case 'every':
                        // keep expression exp
                        break;
                    case 'everyIncr':
                        exp = cronPart.start.toString() + '-' + (parseInt(this.cronIncrement(type))-decr).toString() + '/' + cronPart.interval;
                        break;
                    case 'specific':
                        exp = cronPart.specific.sort(function(a, b) {
                            return a - b;
                        }).toString();
                        break;
                    case 'range':
                        exp = cronPart.start + '-' + cronPart.end;
                        break;
                    case 'specificDay':
                        exp = cronPart.specific.sort(function(a, b) {
                            return a - b;
                        }).toString();
                        break;
                    case 'ldom':
                        exp = 'L';
                        break;
                    case 'dbeom':
                        exp = 'L-' + cronPart.start;
                        break;
                    case 'nthday':
                        exp = this.weekdaysShort[cronPart.end] + '#' + cronPart.start;
                        break;
                    case 'default':
                        exp = '?';
                        break;
                    default:
                        exp = '*';
                        break;
                }

                return exp;
            },
            checkSpecific(type) {
                return this.expressionArray[type].subType === 'specific' && this.expressionArray[type].specific.length === 0
            },
            createExpression() {
                return this.createExpressionPart(this.expressionArray.minute,'minute') + ' ' +
                    this.createExpressionPart(this.expressionArray.hour,'hour') + ' ' +
                    this.createExpressionPart(this.expressionArray.day,'day') + ' ' +
                    this.createExpressionPart(this.expressionArray.month,'month') + ' ' +
                    this.createExpressionPart(this.expressionArray.dow,'dow');
            },
            getSpecificValueByType(type,index) {
                return (type==="year") ? new Date().getFullYear()+index : (type === "month"|| type === "day") ? index + 1 : index
            },
            cronIncrement(type) {
                return (type === 'minute') ? 60 : (type === 'hour') ? 24 : (type === 'day') ? 31 : (type === 'month') ? 12 : 25;
            },
            translatedtype(type){
                return this.translation[type];
            },
            initScript() {
                // set expressionArray from value string expression
                let stringParts = this.value.split(' ');
                var array = ['minute','hour','day','month','dow','year'];

                let start, interval, end, range;

                stringParts.forEach((item,index) => {
                    switch (true) {
                        case item === '*':
                            // keep expression exp
                            this.expressionArray[array[index]] = this.expressionArrayDefault[array[index]];
                            break;
                        case item.includes('-') && item.includes('/'):
                            //range 8-23/2
                            range = item.split('/')[0];
                            interval = item.split('/')[1];
                            start = range.split('-')[0];
                            end = range.split('-')[1];
                            this.expressionArray[array[index]] = {subType: 'everyIncr',specific : [0],interval: interval ,start: start,end: end};
                            break;
                        case item.includes('-'):
                            //range
                            this.expressionArray[array[index]] = {subType: 'range',specific : [0],interval: 1,start: item.split('-')[0],end: item.split('-')[1]};
                            break;
                        case item.includes(','):
                            //specific
                            this.expressionArray[array[index]] = {subType: 'specific',specific : item.split(',').sort(function(a, b) {
                                    return a - b;
                                }),interval: 1, start: 1, end: 1};
                            break;
                        case item.includes('/'):
                            //everyIncr
                            this.expressionArray[array[index]] = {subType: 'everyIncr',specific : [0],interval: item.split('/')[1],start: item.split('/')[0],end: this.cronIncrement(array[index])};
                            break;
                        case !isNaN(item):
                            //specific
                            this.expressionArray[array[index]] = {subType: 'specific',specific : [item],interval: 1,start: 1,end: 1};
                            break;
                        case item.includes('#') && (item.includes('SUN') || item.includes('MON') || item.includes('TUE') || item.includes('WED') || item.includes('THU') || item.includes('FRI') || item.includes('SAT')):
                            //nthday
                            this.expressionArray[array[index]] = {subType: 'nthday',specific : [0],interval: 1,start: item.split('#')[1],end: this.weekdaysShort.indexOf(item.split('#')[0])};
                            break;
                        case item === 'L':
                            //ldom
                            this.expressionArray[array[index]] = {subType: 'ldom',specific : [0],interval: 1,start: 1,end: 1};
                            break;
                        case item === '?':
                            //dom default
                            this.expressionArray[array[index]] = {subType: 'every',specific : [0],interval: 1,start: item,end: 1};
                            break;
                        case item.includes('#'):
                            //dbeom
                            this.expressionArray[array[index]] = {subType: 'every',specific : [0],interval: 1,start: item.split('#')[1],end: item.split('#')[0]};
                            break;
                        default:
                            this.expressionArray[array[index]] = this.expressionArrayDefault[array[index]];
                            break;
                    }});
                this.init = 0;
                this.tick++;
            }
        }
    }
</script>

<style scoped>
    .button {
        padding: 0.75rem 1rem;
        color: #5e72e4;
        font-weight: 500;
        font-size: 0.875rem;
        -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
        background-color: #fff;
        -webkit-transition: all 0.15s ease;
        transition: all 0.15s ease;
    }

    .button:hover {
        background-color: #5e72e4;
        color: #fff;
    }

    .button-active {
        background-color: #e9ecef;
    }

    .select {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
    }

    .item {
        padding: 1rem;
    }

    .nofloat {
        float: none;
    }

    label {
        margin-left: 0.4rem;
    }
</style>